
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[lang]/shop/[slug]",
      function () {
        return require("private-next-pages/[region]/[lang]/shop/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[lang]/shop/[slug]"])
      });
    }
  